// extracted by mini-css-extract-plugin
module.exports = {"passwordIcon":"Form_passwordIcon__eqGY-","keepMeSigned":"Form_keepMeSigned__mivNl","signInBtn":"Form_signInBtn__2vyRx"};